import * as React from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function SelectedDocumentItem(props) {
    const document = props.document

    return (
        <div
            className="selected-document-item"
            onClick={() => props.removeSelectedDocumentItem(document)}>
            <div className="selected-document-item-nid">#{document.nid}</div>
            <div className="selected-document-item-title">
                {decode(document.title)}
            </div>
        </div>
    );
}
